<div class="container-fluid p d-flex h-100 flex-column view_map" id="view_map">
    <div class="row flex-fill d-flex justify-content-center">
        <div class="col-12 d-flex align-items-center">
            <span *ngIf="mapService.activePayload === 'pre_provisioning_kit'" class="search-title">{{"TITLE.POP_CONSEGNA" | translate}}</span>
            <span *ngIf="mapService.activePayload === 'pre_provisioning_svlan'" class="search-title">{{"TITLE.POP_RACCOLTA" | translate}}</span>
            <app-search-place #searchPlace [searchModes]="mapService.searchModes" [actualSearchMode]="actualSearchMode" [popsAutocompleteList]="popsAutocompleteList"
                [options]="setOptions"
                (onSwitchSearchMode)="switchSearchMode($event)" (onSelectedAddress)="onSelectedAddress($event)"
                (onSelectedId)="onSelectedId($event)" (onSelectedCity)="onSelectedCity($event)"
                (onSelectedCluster)="onSelectedCluster($event)" (onSelectedPop)="onSelectPop($event)" (onReset)="reset()" class="w-100"></app-search-place>
        </div>
        <div class="col-12 map-wrapper p-0">
            <app-gmap #map (mapReady)="onMapReady()" (update)="update()"
                (markerClicked)="onMarkerClicked($event)" (clickedButton)="onClickMapButton($event)"></app-gmap>
        </div>
    </div>
</div>

<div *ngIf="wait || waitCivics" class="spinner h-100 w-100 d-flex justify-content-center align-items-center">
	<mat-spinner></mat-spinner>
</div>

<app-modal-loader></app-modal-loader>
<app-modal-coverage-error></app-modal-coverage-error>
<app-modal-multi-building
	[buildings]="modalBuildings"
	(selectBuilding)="onClickBuilding($event)"
></app-modal-multi-building>

<ng-container *ngIf="isPointRequested && (isValidPoint || errorCoverage)">
	<ng-container
		*ngIf="point && (point.type === 'POP' || point.type === 'POP_AGF' || point.type === 'PCN') && isValidPoint"
	>
		<div class="info-box d-flex flex-column justify-content-around">
			<button type="button" class="close-btn" aria-label="Close" (click)="reset()">X</button>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.TOWN" | translate }}</span>
				<span *ngIf="point.pop_details && point.pop_details.comune">{{ point.pop_details.comune }}</span>
				<span *ngIf="!point.pop_details || !point.pop_details.comune">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.POP_ID" | translate }}</span>
				<span *ngIf="point.label && point.label">{{ point.label }}</span>
				<span *ngIf="!point.label || !point.label">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.ADDRESS" | translate }}</span>
				<span *ngIf="point.pop_details && point.pop_details.via">{{ point.pop_details.via }}</span>
				<span *ngIf="!point.pop_details || !point.pop_details.via">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.CIVIC" | translate }}</span>
				<span *ngIf="point.pop_details && point.pop_details.civico">{{ point.pop_details.civico }}</span>
				<span *ngIf="!point.pop_details || !point.pop_details.civico">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.BELONGING_CLUSTER" | translate }}</span>
				<span *ngIf="point.area_type && point.area_type">{{ point.pop_details.cluster }}</span>
				<span *ngIf="!point.pop_details.cluster || !point.pop_details.cluster">-</span>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="point && point.type === 'POINT_CIVIC' && isValidPoint">
		<div class="info-box d-flex flex-column justify-content-around">
			<button type="button" class="close-btn" aria-label="Close" (click)="reset()">
				<i class="fas fa-times"></i>
			</button>
			<div class="info-row">
				<span>
					<strong>{{ "ERRORS.BUILDING_COVERED" | translate }}</strong>
				</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.BUILDING_STATUS" | translate }}</span>
				<span *ngIf="point.marker_details && point.marker_details.status">
					{{ point.marker_details.status }} - {{ point.marker_details.description }}
				</span>
				<span *ngIf="!point.marker_details || !point.marker_details.status">-</span>
				<span *ngIf="point.marker_details && !point.marker_details.description">
					{{ "POINT_DETAILS.NO_DESCRIPTION" | translate }}
				</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.POP_ID" | translate }}</span>
				<span *ngIf="point.marker_details && point.marker_details.afference_pop">
					{{ point.marker_details.afference_pop }}
				</span>
				<span *ngIf="!point.marker_details || !point.marker_details.afference_pop">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.ADDRESS" | translate }}</span>
				<span
					*ngIf="point.marker_details && point.marker_details.address"
					[innerHTML]="point.marker_details.address"
				></span>
				<span *ngIf="!point.marker_details || !point.marker_details.address">-</span>
			</div>
			<div class="info-row">
				<span class="title">{{ "POINT_DETAILS.ID_BUILDING" | translate }}</span>
				<span *ngIf="point.marker_details && point.marker_details.id">{{ point.id }}</span>
				<span *ngIf="!point.marker_details || !point.marker_details.id">-</span>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="errorCoverage && !isValidPoint">
		<div class="info-box d-flex flex-column">
			<button type="button" class="close-btn" aria-label="Close" (click)="reset()">
				<i class="fas fa-times"></i>
			</button>
			<div class="info-row mt-4">
				<strong>{{ errorPlaceholder }}</strong>
			</div>
		</div>
	</ng-container>
</ng-container>
